export default __webpack_public_path__ + "static/media/success-transfer.438a0e5e.svg";